"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalGlobalStyleMixin = void 0;
/** @class ModalGlobalStyleMixin */
/** @method */
var ModalGlobalStyleMixin = function ModalGlobalStyleMixin() {
  return "\n    html,\n    body {\n        overflow: hidden !important;\n\n        // Target mobile safari\n        // https://stackoverflow.com/a/47818418\n        @supports (-webkit-overflow-scrolling: touch) {\n            // iOS Safari does not listen for document clicks by default, this is a workaround\n            // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html\n            cursor: pointer;\n        }\n    }\n";
};
exports.ModalGlobalStyleMixin = ModalGlobalStyleMixin;